export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5028.e328c85e.jpg";